import type { ClientLinkCreateResultV1 } from "@enrein/shared-contracts";

const STORAGE_PREFIX = "enrein:clientLink:";

export interface StoredClientLinkSession {
  readonly clientLinkId: string;
  readonly shellPath: string;
  readonly savedAt: string;
}

function storageKey(projectId: string): string {
  return `${STORAGE_PREFIX}${projectId}`;
}

export function saveClientLinkSession(projectId: string, link: ClientLinkCreateResultV1): void {
  if (typeof sessionStorage === "undefined") {
    return;
  }
  const entry: StoredClientLinkSession = {
    clientLinkId: link.clientLinkId,
    shellPath: link.shellPath,
    savedAt: new Date().toISOString(),
  };
  sessionStorage.setItem(storageKey(projectId), JSON.stringify(entry));
}

export function readClientLinkSession(projectId: string): StoredClientLinkSession | null {
  if (typeof sessionStorage === "undefined") {
    return null;
  }
  const raw = sessionStorage.getItem(storageKey(projectId));
  if (!raw) {
    return null;
  }
  try {
    const parsed = JSON.parse(raw) as StoredClientLinkSession;
    if (
      typeof parsed.clientLinkId !== "string" ||
      typeof parsed.shellPath !== "string" ||
      parsed.clientLinkId.length === 0 ||
      parsed.shellPath.length === 0
    ) {
      return null;
    }
    return parsed;
  } catch {
    return null;
  }
}

export function clearClientLinkSession(projectId: string): void {
  if (typeof sessionStorage === "undefined") {
    return;
  }
  sessionStorage.removeItem(storageKey(projectId));
}
